import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export const Blog = () => {
  const { data: posts = [], isLoading } = useQuery({ queryKey: ["blog"], queryFn: () => api.get("/blog").then((r) => r.data) });
  const [visible, setVisible] = useState(12);

  return (
    <div className="pt-32 pb-24 relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="eyebrow mb-4">Blog</p>
          <h1 className="font-display text-4xl sm:text-6xl text-white max-w-3xl leading-tight">Riflessioni su mindset, crescita e business.</h1>
        </Reveal>

        {isLoading ? (
          <p className="text-zinc-500 mt-16">Caricamento…</p>
        ) : posts.length === 0 ? (
          <p className="text-zinc-500 mt-16">Nessun articolo pubblicato al momento.</p>
        ) : (
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.slice(0, visible).map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.07}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`} className="hover-lift group block h-full bg-[#121212] border border-white/10 rounded-2xl overflow-hidden">
                  {p.cover_image && (
                    <div className="img-zoom h-52 overflow-hidden">
                      <img src={p.cover_image} alt={p.title} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                    </div>
                  )}
                  <div className="p-6">
                    <span className="eyebrow">{p.category}</span>
                    <h2 className="font-display text-xl text-white mt-3 mb-3 leading-snug group-hover:text-[#C19A5B] transition-colors">{p.title}</h2>
                    <p className="text-zinc-400 text-sm leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <span className="inline-flex items-center gap-2 text-[#C19A5B] text-sm mt-5 group-hover:gap-3 transition-all">Leggi <ArrowRight size={15} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
        {!isLoading && posts.length > visible && (
          <div className="mt-14 text-center">
            <button onClick={() => setVisible((v) => v + 12)} data-testid="blog-load-more" className="rounded-full border border-[#C19A5B]/60 text-[#C19A5B] px-8 py-3.5 hover:bg-[#C19A5B]/10 transition-colors">
              Carica altri articoli ({posts.length - visible})
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
